






import { Component, Vue, Prop } from "vue-property-decorator";
import cornerstone from "cornerstone-core";
import cornerstoneMath from "cornerstone-math";
import cornerstoneTools from "cornerstone-tools";
import cornerstoneWebImageLoader from "cornerstone-web-image-loader";
import LiewenTool from "./Liewen";
import DianciTool from "./Dianci";
import YubanyudianTool from "./Yubanyudian";
import Hammer from "hammerjs";
cornerstoneTools.external.cornerstone = cornerstone;
cornerstoneTools.external.Hammer = Hammer;
cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
cornerstoneWebImageLoader.external.cornerstone = cornerstone;
cornerstoneTools.init({
  mouseEnabled: true,
  showSVGCursors: true
});
@Component({})
export default class CsPic extends Vue {
  @Prop()
  private picSrc: any;
  @Prop()
  private tongue: any;
  @Prop()
  private picType: any;
  private t: any = {};
  /**
   * @description 初始化加载工具
   */
  private initTool() {
    // 齿痕
    const RectangleRoiTool = cornerstoneTools.RectangleRoiTool;
    cornerstoneTools.addToolForElement(this.t, RectangleRoiTool, {
      name: "chihen"
    });
    // 裂纹
    cornerstoneTools.addToolForElement(this.t, LiewenTool, {
      name: "liewen"
    });
    // 点刺
    cornerstoneTools.addToolForElement(this.t, DianciTool, {
      name: "dianci"
    });
    // 瘀斑瘀点
    cornerstoneTools.addToolForElement(this.t, YubanyudianTool, {
      name: "yubanyudian"
    });
    // 标尺
    const LengthTool = cornerstoneTools.LengthTool;
    cornerstoneTools.addToolForElement(this.t, LengthTool, {
      name: "biaochi"
    });
    // 移动
    const PanTool = cornerstoneTools.PanTool;
    cornerstoneTools.addToolForElement(this.t, PanTool, {
      name: "yidong"
    });
    // 缩放
    const ZoomTool = cornerstoneTools.ZoomTool;
    cornerstoneTools.addToolForElement(this.t, ZoomTool, {
      name: "suofang"
    });
    // 透镜
    const MagnifyTool = cornerstoneTools.MagnifyTool;
    cornerstoneTools.addToolForElement(this.t, MagnifyTool, {
      name: "toujing"
    });
    // 旋转
    const RotateTool = cornerstoneTools.RotateTool;
    cornerstoneTools.addToolForElement(this.t, RotateTool, {
      name: "xuanzhuan"
    });
  }
  /**
   * @description 齿痕
   */
  private chihen() {
    // cornerstoneTools.removeTool("liewen");

    cornerstoneTools.setToolActive("chihen", {
      mouseButtonMask: 1
    });
  }
  /**
   * @description 裂纹
   */
  private liewen() {
    cornerstoneTools.setToolActive("liewen", {
      mouseButtonMask: 1
    });
  }
  /**
   * @description 点刺
   */
  private dianci() {
    cornerstoneTools.setToolActive("dianci", {
      mouseButtonMask: 1
    });
  }
  /**
   * @description 瘀斑瘀点
   */
  private yubanyudian() {
    cornerstoneTools.setToolActive("yubanyudian", {
      mouseButtonMask: 1
    });
  }
  /**
   * @description 标尺
   */
  private biaochi() {
    cornerstoneTools.setToolActive("biaochi", {
      mouseButtonMask: 1
    });
  }
  /**
   * @description 手动分割
   */
  private fenge() {
    const FreehandRoiTool = cornerstoneTools.FreehandRoiTool;
    cornerstoneTools.addToolForElement(this.t, FreehandRoiTool, {
      name: "fenge"
    });
    cornerstoneTools.setToolActive("fenge", {
      mouseButtonMask: 1
    });
  }
  /**
   * @description 清除前一次分割
   */
  private clearFenge() {
    cornerstoneTools.clearToolState(this.t, "fenge");
    cornerstone.reset(this.t);
    cornerstoneTools.setToolActive("fenge", {
      mouseButtonMask: 1
    });
  }
  /**
   * @description 获得分割数据
   */
  private getFengeData() {
    console.log(cornerstone.getImage(this.t));
    const image = cornerstone.getImage(this.t);
    const result = cornerstoneTools.getToolState(this.t, "fenge");
    if (result) {
      if (result.data.length > 1) {
        this.$message.warning("只能有一条分割线");
        return;
      }
      const d = result.data[0].handles.points;
      const points: any = [];
      d.map((point: any) => {
        points.push([point.x, point.y]);
      });
      return {
        points,
        width: image.width,
        height: image.height
      };
    }
  }
  /**
   * @description 移动
   */
  private yidong() {
    cornerstoneTools.setToolActive("yidong", {
      mouseButtonMask: 1
    });
  }
  /**
   * @description 缩放
   */
  private suofang() {
    cornerstoneTools.setToolActive("suofang", {
      mouseButtonMask: 1
    });
  }
  /**
   * @description 透镜
   */
  private toujing() {
    cornerstoneTools.setToolActive("toujing", {
      mouseButtonMask: 1
    });
  }
  /**
   * @description 旋转
   */
  private xuanzhuan() {
    cornerstoneTools.setToolActive("xuanzhuan", {
      mouseButtonMask: 1
    });
  }
  /**
   * @description 截屏
   */
  private jieping() {
    const time = new Date();
    const year = time.getFullYear();
    const month = time.getMonth() + 1;
    let date: any = time.getDate();
    if (date < 10) {
      date = "0" + date;
    }
    cornerstoneTools.SaveAs(
      this.t,
      "TcmImageCenter-" +
        year +
        month +
        date +
        "-" +
        this.tongue["姓名"] +
        this.tongue.tongue_id
    );
  }
  /**
   * @description 还原
   */
  private huanyuan() {
    cornerstoneTools.clearToolState(this.t, "chihen");
    cornerstoneTools.clearToolState(this.t, "liewen");
    cornerstoneTools.clearToolState(this.t, "dianci");
    cornerstoneTools.clearToolState(this.t, "yubanyudian");
    cornerstoneTools.clearToolState(this.t, "biaochi");
    cornerstone.reset(this.t);
  }
  /**
   * @description 展示图片
   */
  private reload() {
    this.t = this.$refs.canvas;
    cornerstone.enable(this.t);
    // console.log(cornerstone);
    cornerstone
      .loadImage(this.picSrc + "?t=" + +new Date())
      .then((image: any) => {
        // console.log(image);
        image.columnPixelSpacing = 0.5;
        image.rowPixelSpacing = 0.5;
        cornerstone.displayImage(this.t, image);
        if (this.picType === "origin") {
          this.renderGuiji();
        }

        // console.log(cornerstoneTools);
      });
  }
  /**
   * @description 渲染已有的轨迹
   */
  private renderGuiji() {
    if (this.tongue["轨迹"]) {
      // 齿痕
      if (this.tongue["轨迹"]["齿痕"].length > 0) {
        cornerstoneTools.setToolActive("chihen", {
          mouseButtonMask: 1
        });
        this.tongue["轨迹"]["齿痕"].map((item: any) => {
          // console.log(item);
          cornerstoneTools.addToolState(this.t, "chihen", item);
        });
        cornerstoneTools.setToolPassive("chihen");
      }
      // 裂纹
      if (this.tongue["轨迹"]["裂纹"].length > 0) {
        cornerstoneTools.setToolActive("liewen", {
          mouseButtonMask: 1
        });
        this.tongue["轨迹"]["裂纹"].map((item: any) => {
          // console.log(item);
          cornerstoneTools.addToolState(this.t, "liewen", item);
        });
        cornerstoneTools.setToolPassive("liewen");
      }
      // 点刺
      if (this.tongue["轨迹"]["点刺"].length > 0) {
        cornerstoneTools.setToolActive("dianci", {
          mouseButtonMask: 1
        });
        this.tongue["轨迹"]["点刺"].map((item: any) => {
          // console.log(item);
          cornerstoneTools.addToolState(this.t, "dianci", item);
        });
        cornerstoneTools.setToolPassive("dianci");
      }
      // 瘀斑瘀点
      if (this.tongue["轨迹"]["瘀斑瘀点"].length > 0) {
        cornerstoneTools.setToolActive("yubanyudian", {
          mouseButtonMask: 1
        });
        this.tongue["轨迹"]["瘀斑瘀点"].map((item: any) => {
          // console.log(item);
          cornerstoneTools.addToolState(this.t, "yubanyudian", item);
        });
        cornerstoneTools.setToolPassive("yubanyudian");
      }
    }
    // 强制改变模式为移动
    this.yidong();
  }
  /**
   * @description 获取标记数据
   */
  private collectData() {
    const message: any = {
      齿痕: cornerstoneTools.getToolState(this.t, "chihen")
        ? cornerstoneTools.getToolState(this.t, "chihen").data
        : [],
      裂纹: cornerstoneTools.getToolState(this.t, "liewen")
        ? cornerstoneTools.getToolState(this.t, "liewen").data
        : [],
      点刺: cornerstoneTools.getToolState(this.t, "dianci")
        ? cornerstoneTools.getToolState(this.t, "dianci").data
        : [],
      瘀斑瘀点: cornerstoneTools.getToolState(this.t, "yubanyudian")
        ? cornerstoneTools.getToolState(this.t, "yubanyudian").data
        : []
    };
    return message;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.t = this.$refs.canvas;
    cornerstone.enable(this.t);
    // console.log(cornerstone);
    cornerstone
      .loadImage(this.picSrc + "?t=" + +new Date())
      .then((image: any) => {
        // console.log(image);
        image.columnPixelSpacing = 0.5;
        image.rowPixelSpacing = 0.5;
        cornerstone.displayImage(this.t, image);
        this.initTool();
        if (this.picType === "origin") {
          this.renderGuiji();
        }
        // console.log(cornerstoneTools);
      });
  }
  private test(e) {
    // console.log(e);
    // const result = cornerstone
    //   .getEnabledElement(this.t)
    //   .toolStateManager.get(this.t, "fenge");
    // console.log(result);
  }
}
